import React, { Component } from 'react';
import './GoogleMap.css';

declare var google;
declare var $;

class GoogleMap extends Component {

   constructor(props) {
     super(props)
     this.state  = {
       newAddress: {},
       map: [],
       marker: [],
       circle: [],
       address_description: '',
       loadingCurrentPosition: false,
       autocomplete: [],
       showMap: false
     }

     this.getCurrentPosition = this.getCurrentPosition.bind(this)
     this.initGoogleMap = this.initGoogleMap.bind(this)
     this.geocodePosition = this.geocodePosition.bind(this)
     this.updateAddressDescription = this.updateAddressDescription.bind(this);
     this.initAutocomplete = this.initAutocomplete.bind(this);
     this.setCenter = this.setCenter.bind(this);
     this.geolocFail = this.geolocFail.bind(this);
   }

   componentDidMount() {
     this.initGoogleMap();
     this.initAutocomplete();
     this.getCurrentPosition();
     this.refs.address.focus()
   }

   componentWillReceiveProps(nextProps) {
     if(nextProps.needAddress) {
       this.props.setAddress(this.state.newAddress)
     }
   }

   initGoogleMap() {
     let map = new google.maps.Map(this.refs.map, {
       zoom: 18,
       center: {lat: -74.063644 , lng: 4.624335 },
       mapTypeControl: false,
       streetViewControl: false,
     });

     var marker = new google.maps.Marker({
         position: {lat: this.state.newAddress.lat , lng: this.state.newAddress.lat },
         map: map,
         draggable: true,
         animation: google.maps.Animation.DROP,
         icon: {url:'/assets/img/icons/rappi-marker.png', scaledSize: new google.maps.Size(40, 40)},

       });
       this.setState({
          map,
          marker,
       })
       google.maps.event.addListener(marker, 'dragend', () => {
         let lat = marker.getPosition().lat();
         let lng = marker.getPosition().lng();
         this.geocodePosition({lat: lat, lng: lng})
       });
   }


   initAutocomplete() {
     let autocomplete = new google.maps.places.Autocomplete(this.refs.address, {
        types: ["address"]
      });
      let circle = new google.maps.Circle({
         center: {lat: this.state.newAddress.lat , lng: this.state.newAddress.lat },
         radius: 100,
         });
      this.setState({
        circle,
        autocomplete
      })
      autocomplete.setBounds(circle.getBounds());
      autocomplete.addListener("place_changed", () => {
          this.refs.map.style.height = '200px';
          let place = autocomplete.getPlace();
          let newAddress = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            address: place.formatted_address,
            tag: 'Otro',
            description: this.state.address_description
          }
          this.setCenter(place.geometry.location.lat(),place.geometry.location.lng())
          this.setState({
            newAddress
          })
      })
   }

   getCurrentPosition() {

       if ("geolocation" in navigator) {
         this.setState({
           loadingCurrentPosition: true
         })
         this.refs.address.value = "Cargando tu ubicacion...";
         navigator.geolocation.getCurrentPosition(
          (success) => {
              this.setState({
                showMap: true
              });
             this.geocodePosition({lat: success.coords.latitude, lng: success.coords.longitude})
             this.setCenter(success.coords.latitude, success.coords.longitude);
           },
           (error) => {
                this.geolocFail()
           } , {timeout: 10000})
       } else {
           this.geolocFail()
       }
   }

   geolocFail() {
     let lat, lng;
     if(localStorage.getItem('country') === 'co') {
       lat = 4.624335;
       lng = -74.063644;
     } else {
       lat = 19.432608;
       lng = -99.133209;
     }
     this.setCenter(lat,lng)
     this.setState({
       loadingCurrentPosition: false,
     });
     this.refs.address.value = "";
     this.refs.address.focus()
   }

   geocodePosition(position) {
     let geocoder = new google.maps.Geocoder();
     geocoder.geocode({
       latLng: position
     }, (responses) => {
       if (responses && responses.length > 0) {
         this.setState({
           loadingCurrentPosition: false
         })
         this.refs.address.focus()
         this.refs.address.value = responses[0].formatted_address;
         let newAddress = {
           lat: position.lat,
           lng: position.lng,
           address: responses[0].formatted_address,
           tag: 'Otro',
           description: this.state.address_description
         }
         this.setState({
           newAddress,
         })
       }
     });
   }

   setCenter(lat, lng) {
     let LatLng = {
       lat: lat,
       lng: lng
     }
     var infowindow = new google.maps.InfoWindow({
      content: "Mueve el marcador para ubicar tu posición exacta!",
       pixelOffset: new google.maps.Size(200,100)
    });
    infowindow.open(this.state.map, this.state.marker);
   setTimeout(() =>  {infowindow.close();} , 5000)
     this.state.map.setCenter(LatLng)
     this.state.marker.setPosition(LatLng)
     this.state.circle.setCenter(LatLng)
     this.state.autocomplete.setBounds(this.state.circle.getBounds());
   }

   updateAddressDescription(event) {
     let address_description = event.target.value;
     let newAddress = this.state.newAddress
     newAddress.description = address_description;
     this.setState({
       newAddress,
       address_description
     })
   }

  render() {
    let country = localStorage.getItem('country');
    let placeholder = country === 'co' ? 'Escribe aqui tu dirección Ej: Calle 93# 10 - 9' : 'Escribe aqui tu dirección Ej: Paseo de la Reforma 99';

    return (
      <div className="container">
          <input ref="address"  autoFocus disabled={this.state.loadingCurrentPosition} placeholder={placeholder}
          className="maps-input col-md-6 col-xs-10 col-md-offset-3 col-xs-offset-1 animated bounceInLeft"/>
           {!this.state.loadingCurrentPosition &&
             <input value={this.state.address_description} onChange={this.updateAddressDescription} placeholder="Piso/Oficina/Apto/Dpto Ej: Oficina 304" className="maps-input description col-md-4 col-xs-10 col-md-offset-4 col-xs-offset-1 animated bounceInLeft"/>
           }
         <div className="mapi" ref="map"></div >

      </div>
    );
  }


}
export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/addresses/google-map/GoogleMap.js